var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log"},_vm._l((_vm.log),function(entry){return _c('ModListUserGuildLogEntryComp',{key:entry.id,attrs:{"entry":entry}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }